import React from 'react'
import {
  Header,
  Label
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import ScreenContainer from './ScreenContainer.js'
import TopicTable from './TopicTable.js'
import OutcomeTable from './OutcomeTable.js'
import ItemCounter from './ItemCounter.js'
import { areas } from './curriculum.js'

function countTopics(topics) {
  let count = 0;
  topics.forEach((topic)=>{
    count++;
    topic.topics && topic.topics.forEach((subtopic)=>{
      count++;
      subtopic.topics && subtopic.topics.forEach((subsubtopic)=>{
        count++;
      });
    });
  });
  return count;
}
const Unit = (props) => {
  const { location, match, mode, selection, selections, comparisonMode, comparisonSelectionNames, onToggle } = props;
  console.log("Unit::render()", props);
  let area;
  let unit;
  if (match.params.areaid && match.params.unitname) {
    area = areas.filter(area=>area.id===match.params.areaid)[0];
    unit = area.units.filter(unit=>unit.name===match.params.unitname)[0];
  } else if (match.params.unitfqid) {
    //console.log("unitfqid:", match.params.unitfqid);
    const rx = /([A-Z]+)([0-9]+)/;
    const m = match.params.unitfqid.match(rx);
    const areaid = m[1];
    const unitid = m[2];
    area = areas.filter(area=>area.id===areaid)[0];
    unit = area.units.filter(unit=>unit.id===unitid)[0];
  }
  const chosenFqid = location?location.hash?location.hash.substring(1):null:null;
  return (
    <ScreenContainer mode={mode}>
      <Header as='h1'>
        <Header.Subheader>
          <Link to='/areas'>Areas</Link> / <Link to={'/area/'+area.id}>{area.name}</Link> / {unit.name}
        </Header.Subheader>
        {unit.name} <span style={{fontWeight: 'lighter', fontVariant: 'all-small-caps'}}>({unit.fqid})</span>
      </Header>
      <Header as='h2'>
        Topics
        <span>
          <Label circular>{countTopics(unit.topics)}</Label>
        </span>
        {
          mode==='select'&&selection
          ?
          <span style={{marginLeft: '10px'}}>
            <i className='small tasks icon'/>
            <ItemCounter itemKind='topics' items={selection.items} fqidPrefix={unit.fqid+"."} type={selection.type}/>
          </span>
          :
          null
        }
      </Header>
      <TopicTable
        topics={unit.topics}
        mode={mode}
        selection={selection}
        selections={selections}
        chosenFqid={chosenFqid}
        comparisonMode={comparisonMode}
        comparisonSelectionNames={comparisonSelectionNames}
        onToggle={onToggle}
      />
      <Header as='h2'>
        Learning Outcomes
        <span>
          <Label circular>{unit.outcomes.length}</Label>
        </span>
        {
          mode==='select'&&selection
          ?
          <span style={{marginLeft: '10px'}}>
            <i className='small tasks icon'/>
            <ItemCounter itemKind='outcomes' items={selection.items} fqidPrefix={unit.fqid+"o"} type={selection.type}/>
          </span>
          :
          null
        }
      </Header>
      <OutcomeTable
        outcomes={unit.outcomes}
        mode={mode}
        selection={selection}
        selections={selections}
        chosenFqid={chosenFqid}
        comparisonMode={comparisonMode}
        comparisonSelectionNames={comparisonSelectionNames}
        onToggle={onToggle}
      />
    </ScreenContainer>
  )
}

export default Unit